import React, { useEffect, useState } from 'react';
import './Toast.scss';

export const Toast = ({
  message,
  type = 'default',
  duration = 4000,
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Auto-dismiss after duration
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      // Wait for CSS transition to complete before removing from DOM
      setTimeout(() => {
        if (onClose) {
          onClose();
        }
      }, 300);
    }, duration);

    return () => {
      clearTimeout(hideTimer);
    };
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, 300); // Wait for exit animation
  };

  const getIcon = () => {
    switch (type) {
      case 'error':
        return '❌';
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      default:
        return 'ℹ️';
    }
  };

  return (
    <div
      className={`gigacore-toast gigacore-toast--${type} ${
        isVisible ? 'gigacore-toast--show' : ''
      }`}
    >
      <div className='gigacore-toast__content'>
        <div className='gigacore-toast__icon'>{getIcon()}</div>
        <div className='gigacore-toast__message'>{message}</div>
        <button
          className='gigacore-toast__close'
          onClick={handleClose}
          aria-label='Close notification'
        >
          ×
        </button>
      </div>
    </div>
  );
};
